var prevScrollpos = window.pageYOffset;
window.onscroll = function () {
  var currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos || prevScrollpos < 0) {
    document.getElementById("hide-and-show").style.top = "0";
  } else {
    document.getElementById("hide-and-show").style.top = "-110px";
  }
  prevScrollpos = currentScrollPos;
};
